module.exports = "/assets/d1a3778df91c61ae0c25f8a2eb754a7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/U5.png
// module id = 2998
// module chunks = 0